module.exports = __webpack_public_path__ + "static/img/红外.8f20b869.png";